import React from 'react'
import { Tag, Tooltip } from 'antd'
import { Theme } from 'Components/common'
import { InfoCircleFilled } from '@ant-design/icons'
import theme from 'Components/common/Theme'

type Props = {
  isOverstock?: boolean
}

const OverstockTag = (props: Props) => {
  const { isOverstock } = props
  return (
    <Tooltip
      placement="bottom"
      title="ขายสินค้านอกสต๊อก คือ จำนวนสต๊อกสินค้าที่ทางร้านต้องการขายมากกว่าจำนวนสต๊อกที่มีในปัจจุบัน โดยระบบจะไม่นำจำนวนไปตัดสต๊อกที่มีในปัจจุบันของร้าน"
    >
      <Tag color={Theme.colors.primary} visible={isOverstock} style={{ cursor: 'pointer' }}>
        <InfoCircleFilled color={theme.colors.primary} /> ขายสินค้านอกสต็อก
      </Tag>
    </Tooltip>
  )
}

export default OverstockTag
